//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  export default {
    data () {
      return {}
    },
    methods: {
      toHome () {
        this.$router.push({path: '/home'})
      },
      menuClick (path, query) {
        if (typeof path !== 'string') return
        if (query === undefined) {
          this.$router.replace(path)
        } else {
          this.$router.push({
            'path': path,
            query
          })
        }
      },
      showDialog (flag = true) {
        let menuDialog = this.$refs.menuDialog
        try {
          // bounceOut
          if (flag) {
//            this.showUserDialog(false)
            menuDialog.classList.toggle('show')
          } else {
            menuDialog.classList.remove('show')
          }
        } catch (e) {
          // console.log(e)
        }
      },
      showUserDialog (flag = true) {
        this.$router.push({path: '/personalCenter'})   // 点击直接跳转至个人中心页面
//        let userDialog = this.$refs.userDialog
//        try {
//          if (flag) {
//            this.showDialog(false)
//            userDialog.classList.toggle('show')
//          } else {
//            userDialog.classList.remove('show')
//          }
//        } catch (e) {
//          // console.log(e)
//        }
      }
    },
    mounted () {
      let _this = this
      window.document.body.addEventListener('click', function (e) {
        e = e || window.event
        let target = e.target
        if (target.className === 'menu app-header-menu' || target.className === 'persion app-header-user app-mr10') return
        _this.showDialog(false)
//        _this.showUserDialog(false)
      })
    }
  }



// WEBPACK FOOTER //
// ./src/components/simple/appHeader/App-header.vue